/**
 * Query keys for Power BI reports (POC)
 */
export const reportKeys = {
  all: ['reports'] as const,
  /** Reports listed from a workspace (the Reports catalog). */
  list: (groupId: string) => [...reportKeys.all, 'list', groupId] as const,
  embedConfig: (reportId: string) =>
    [...reportKeys.all, 'embed-config', reportId] as const,
};
